import React from 'react';

export const InputForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Label
        </label>
        <input
          type="text"
          value={specificAttrs.label || ''}
          onChange={(e) => handleChange('label', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Placeholder
        </label>
        <input
          type="text"
          value={specificAttrs.placeholder || ''}
          onChange={(e) => handleChange('placeholder', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Type
          </label>
          <select
            value={specificAttrs.type || 'text'}
            onChange={(e) => handleChange('type', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          >
            <option value="text">Text</option>
            <option value="email">Email</option>
            <option value="password">Password</option>
            <option value="number">Number</option>
            <option value="tel">Phone</option>
            <option value="url">URL</option>
            <option value="date">Date</option>
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
            Name
          </label>
          <input
            type="text"
            value={specificAttrs.name || ''}
            onChange={(e) => handleChange('name', e.target.value)}
            style={{
              width: '100%',
              padding: '6px 10px',
              fontSize: '13px',
              border: '1px solid #D1D5DB',
              borderRadius: '6px'
            }}
          />
        </div>
      </div>
      <div style={{ display: 'flex', gap: '16px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.required}
            onChange={(e) => handleChange('required', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>Required</span>
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.disabled}
            onChange={(e) => handleChange('disabled', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>Disabled</span>
        </label>
      </div>
    </div>
  );
};
